/* eslint-disable no-useless-escape */
/* eslint-disable no-useless-backreference */
import examApi from '@/api/exam.api'
import { ExamSchedule } from '@/dto/Exam/ExamSchedule'
import type { YearMonthStr } from '@/types'

import { makeAdapter } from './Adapter'
import type Controller from './Controller'

export class ExamController implements Controller {
  adapter = {
    examSchedule: makeAdapter({
      from(data: res.ExamSchedule) {
        return new ExamSchedule(data)
      },
    }),
  }

  async assignStudentExam(
    examId: res.AssignedExam['id'],
    studentIdList: res.AssignedStudent['studentId'][],
  ) {
    const {
      data: { data },
    } = await examApi.postAssignExamToStudent(examId, studentIdList)
    return data
  }

  async unAssignStudentExam(studentExamId: res.AssignedStudent['studentWorksheetId'][]) {
    await examApi.deleteExamStudent(studentExamId)
  }

  async getReport(
    param:
      | { type: 'EXAM'; examId: res.AssignedExam['id'] }
      | {
          type: 'STUDENT_EXAM'
          examId: res.AssignedExam['id']
          studentId: res.AssignedStudent['studentId']
        }
      | {
          type: 'EXAM_SCHEDULE'
          yearMonth: string
          examType: res.AssignedExam['examType']
        },
  ) {
    const res = await examApi.getReport(param)
    return res.data
  }

  async getExamSchedule(type: res.AssignedExam['examType'] = 'KMM') {
    const { data } = await examApi.getExamSchedule(type)
    return data.map(this.adapter.examSchedule.from)
  }

  async getExamByYearMonth({
    yearMonth,
    type = 'KMM',
  }: {
    yearMonth: YearMonthStr<'-'>
    type?: res.AssignedExam['examType']
  }) {
    const { data } = await examApi.getExamByYearMonth(yearMonth, type)
    return data
  }

  async getExamAwardByYearMonth({
    yearMonth,
    type = 'KMM',
  }: {
    yearMonth: YearMonthStr<'-'>
    type?: res.AssignedExam['examType']
  }) {
    const { data } = await examApi.getExamAwardByYearMonth(yearMonth, type)
    return data
  }
}

export const examController = new ExamController()
